<template>
    <div class="user-profile">
        <form @submit.prevent="validateForm">
            <div class="form-group">
                <div class="mt-2 mb-2">
                    <b>
                        {{ !isIphUser ? 'Residential Address' : 'Office Address' }}
                    </b>
                </div>
                <div class="form-group required">
                    <label>Address Line 1</label>
                    <input type="text" name="addressLine1" data-vv-as="address line 1" data-vv-validate-on="blur"
                        placeholder="Address Line 1" v-model="value.addressLine1" v-validate="'required'" :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('addressLine1')
                    }">

                    <div v-show="validationErrors.has('addressLine1')" class="invalid-feedback">
                        {{ validationErrors.first('addressLine1') }}
                    </div>
                </div>

                <div class="form-group">
                    <label>Address Line 2</label>
                    <input type="text" class="form-control" placeholder="Address Line 2" v-model="value.addressLine2">
                </div>

                <div class="form-row">
                    <div class="form-group col-lg-6 col-md-6 required">
                        <label>City</label>
                        <input type="text" name="city" data-vv-validate-on="blur" placeholder="City" v-model="value.addressCity"
                            v-validate="'required'" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('city')
                        }">
                        <div v-show="validationErrors.has('city')" class="invalid-feedback">
                            {{ validationErrors.first('city') }}
                        </div>
                    </div>

                    <div class="form-group col-lg-4 col-md-6 required">
                        <label>State</label>
                        <select name="state" data-vv-validate-on="blur" v-model="value.addressState" v-validate="'required'"
                            :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('state')
                        }">
                            <option :value="null">Choose...</option>
                            <option v-for="(state, index) in malaysiaStates" :key="index" :value="state.value">
                                {{state.text}}
                            </option>
                        </select>
                        <div v-show="validationErrors.has('state')" class="invalid-feedback">
                            {{ validationErrors.first('state') }}
                        </div>
                    </div>

                    <div class="form-group col-lg-2 col-md-12 required">
                        <label>Postal Code</label>
                        <input type="text" name="postcode" placeholder="Postal Code" data-vv-validate-on="blur" v-model="value.addressPostcode"
                            v-validate="'required'" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('postcode')
                        }">
                        <div v-show="validationErrors.has('postcode')" class="invalid-feedback">
                            {{ validationErrors.first('postcode') }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <div class="mt-2 mb-2">
                    <b>Mailing Address</b>
                </div>

                <div class="mb-2">
                    <div class="form-check">
                        <label class="form-check-label d-flex align-items-center">
                            <input class="form-check-input" type="checkbox" v-model="isMailSameAsResidential">
                            <span>My mailing address is the same as my {{ !isIphUser ? 'residential' : 'office' }} address.</span>
                        </label>
                    </div>
                </div>

                <div v-show="!isMailSameAsResidential">
                    <div class="form-group required">
                        <label>Address Line 1</label>
                        <input type="text" name="mailingAddressLine1" data-vv-as="address line 1" data-vv-validate-on="blur"
                            placeholder="Address Line 1" v-model="value.mailingAddressLine1" v-validate="'required'" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('mailingAddressLine1')
                        }">

                        <div v-show="validationErrors.has('mailingAddressLine1')" class="invalid-feedback">
                            {{ validationErrors.first('mailingAddressLine1') }}
                        </div>
                    </div>

                    <div class="form-group">
                        <label>Address Line 2</label>
                        <input type="text" class="form-control" placeholder="Address Line 2" v-model="value.mailingAddressLine2">
                    </div>

                    <div class="form-row">
                        <div class="form-group col-lg-6 col-md-6 required">
                            <label>City</label>
                            <input type="text" name="mailingCity" data-vv-as="city" data-vv-validate-on="blur"
                                placeholder="City" v-model="value.mailingAddressCity" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('mailingCity')
                            }">
                            <div v-show="validationErrors.has('mailingCity')" class="invalid-feedback">
                                {{ validationErrors.first('mailingCity') }}
                            </div>
                        </div>

                        <div class="form-group col-lg-4 col-md-6 required">
                            <label>State</label>
                            <select name="mailingState" data-vv-validate-on="blur" data-vv-as="state" v-model="value.mailingAddressState"
                                v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('mailingState')
                            }">
                                <option :value="null">Choose...</option>
                                <option v-for="(state, index) in malaysiaStates" :key="index" :value="state.value">
                                    {{state.text}}
                                </option>
                            </select>
                            <div v-show="validationErrors.has('mailingState')" class="invalid-feedback">
                                {{ validationErrors.first('mailingState') }}
                            </div>
                        </div>

                        <div class="form-group col-lg-2 col-md-12 required">
                            <label>Postal Code</label>
                            <input type="text" name="mailingPostcode" placeholder="Postal Code" data-vv-as="postcode"
                                data-vv-validate-on="blur" v-model="value.mailingAddressPostcode" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('mailingPostcode')
                            }">
                            <div v-show="validationErrors.has('mailingPostcode')" class="invalid-feedback">
                                {{ validationErrors.first('mailingPostcode') }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import malaysiaStates from '@/config/malaysiaStates';
import profileMixins from './profileMixins';
export default {
    'name': 'DoctorProfileComponent',
    'props': {
        'value': Object
    },
    'computed': {
        isIphUser () {
            return this.$store.state.user.userRole === 998;
        }
    },
    'mixins': [
        profileMixins
    ],
    'watch': {
        isMailSameAsResidential (val) {
            if (val) {
                // set mailing address to same as residential address
                this.value.mailingAddressLine1 = this.value.addressLine1;
                this.value.mailingAddressLine2 = this.value.addressLine2;
                this.value.mailingAddressCity = this.value.addressCity;
                this.value.mailingAddressState = this.value.addressState;
                this.value.mailingAddressPostcode = this.value.addressPostcode;
            }
        }
    },
    data () {
        return {
            malaysiaStates,
            'isMailSameAsResidential': false
        };
    },
    mounted () {

    },
    'methods': {
        validateForm () {
            // set before validation
            if (this.isMailSameAsResidential) {
                // set mailing address to same as residential address
                this.value.mailingAddressLine1 = this.value.addressLine1;
                this.value.mailingAddressLine2 = this.value.addressLine2;
                this.value.mailingAddressCity = this.value.addressCity;
                this.value.mailingAddressState = this.value.addressState;
                this.value.mailingAddressPostcode = this.value.addressPostcode;
            }

            return this.$validator.validateAll();
        }
    }
};

</script>

<style>

</style>
